import { StyleSheet } from 'react-native';

import { Text, tokens } from '@fhs/ui';

export default function FormFieldTitle({ title, required }: { title: string; required: boolean }) {
  // shared component for the field label; shows an asterisk for the required fields
  return (
    <Text.Ui size="md" weight="bold" style={styles.label}>
      {title}
      {required && (
        <Text.Ui size="md" weight="bold" style={styles.requiredField}>
          *
        </Text.Ui>
      )}
    </Text.Ui>
  );
}

const styles = StyleSheet.create({
  label: {
    marginBottom: 8,
  },
  requiredField: { color: tokens.colors.$error, paddingLeft: 1 },
});
